module.exports = __webpack_public_path__ + "img/honda-New.7aa79e81.png";